import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import CommonNavbar from '../../Navbar/CommonNavbar';

const ProjectViewPage_header = ({ onSearch, disableSearch = false }) => {

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    navigate(path); 
  };

  return (
    <div>
      <header>
        <nav className="nav-items">
          <p>Project</p>
          <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />
        </nav>
      </header>
    </div>
  )
}

export default ProjectViewPage_header
